import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

interface SelectOption {
	label: string;
	value: string;
}
export const multiply = (x: number, y: number) => {
	return x * y;
};

export const transformDataToSelectOptions = <T extends Record<string, any>>(
	data: T[],
	labelKey: keyof T,
	valueKey: keyof T
): SelectOption[] => {
	return data?.map(item => ({
		label: String(item[labelKey]),
		value: String(item[valueKey])
	}));
};

export function tableDateFormatter(text: string | null, format: string) {
	if (!text) {
		return "";
	}
	const localDate = dayjs.utc(text).tz(dayjs.tz.guess());
	const formattedDate = localDate.isValid()
		? localDate.format(format)
		: dayjs().format(format);
	return formattedDate;
}

export const formatNumber = (number: number) => {
	if (number === null || number === undefined) {
		return "";
	}
	return new Intl.NumberFormat("de-DE").format(number);
};

export const checkIfValueisFloat = /^[0-9]*,?[0-9]{0,2}$/;

export const formatValue = (inputValue: string) => {
	
	let validInput = inputValue.replace(/[^\d,]/g, "").replace(/^,/, "").replace(/(,.?),(.,)?/, "$1");

	const parts = validInput.split(",");

	if (parts[1]) {
		parts[1] = parts[1].substring(0, 2);
	}

	validInput = parts.join(",");

	parts[0] = parts[0].replace(/\./g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");

	return parts.length > 1 ? parts.join(",") : parts[0];
};

export const convertDecimalToFloat = (value: string | null): number | null => {
	if (value === null) return null;

	const stringValue = String(value);
	if (!stringValue) {
		return null;
	}
	const noThousandsSeparators = stringValue.replace(/\./g, "");
	const convertedDecimalSeparator = noThousandsSeparators.replace(",", ".");
	const result = parseFloat(convertedDecimalSeparator);

	return isNaN(result) ? null : result;
};

export const convertCommaToDot = (value: string) => {
	return value.replace(",", ".");
};

export const convertDotToComma = (value: number) => {
	return value.toString().replace(".", ",");
};